import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { Component, OnInit } from '@angular/core';
import {
  AdvisorData,
  BrandingService,
  CompanyBrandingHelper,
  IdentityVerificationMethod,
  SsoAccountData,
  SsoAccountFacade,
  SessionStorageKey,
  SessionStorageState,
} from 'common';
import { VerifyIdentityFacade } from './verify-identity.facade';
import { combineLatest } from 'rxjs';
import { EntityFacade } from '../../../entity/domain/+state/entity.facade';
import { ActivatedRoute } from '@angular/router';
import { IdVerseContentConfig } from 'common';

@UntilDestroy()
@Component({
    selector: 'ifp-verify-identity',
    templateUrl: './verify-identity.component.html',
    styleUrls: ['./verify-identity.component.scss'],
    providers: [VerifyIdentityFacade],
    standalone: false
})
export class VerifyIdentityComponent implements OnInit {
  currentMethod: IdentityVerificationMethod;
  advisorData: AdvisorData;
  loanId: string;
  idVerseConfig: IdVerseContentConfig = { showMobileAppPromo: true };

  readonly IdentityVerificationMethod = IdentityVerificationMethod;

  constructor(
    private readonly ssoAccountFacade: SsoAccountFacade,
    private readonly facade: VerifyIdentityFacade,
    private readonly brandingService: BrandingService,
    private readonly entityFacade: EntityFacade,
    private readonly route: ActivatedRoute,
  ) {
    SessionStorageState.set(SessionStorageKey.AccountSetupViewed, true);
  }

  ngOnInit(): void {
    this.initLoanId();
    this.initData();
  }

  private initLoanId(): void {
    this.loanId = this.route.snapshot.queryParams['loanId'];
  }

  private initData(): void {
    combineLatest([
      this.entityFacade.getEntity$(null),
      this.brandingService.getBranding$(),
      this.ssoAccountFacade.getSsoAccountCheckoutState$()
    ]).pipe(untilDestroyed(this)).subscribe(([entity, branding, checkoutState]) => {
      this.advisorData = {
        fullName: entity?.advisorName,
        email: entity?.advisorEmail,
        phone: CompanyBrandingHelper.getAdvisorPhone(branding, entity?.advisorPhone)
      };
      this.currentMethod = checkoutState?.method;
    });
  }

  onVerified(currentAccont: SsoAccountData): void {
    this.facade.handleVerifyIdentitySuccessRedirect(currentAccont);
  }

  onIdVerseFailedNoRetry(isExpired: boolean): void {
    this.facade.handleIdVerseFailedRedirect(isExpired);
  }
}
